/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
